import { SellingMode, type ScheduleTime } from '@src/core/buyerApiClient';
import { intersectCommonScheduleTimes } from '@src/domains/scheduling/core/intersectCommonScheduleTimes';
import { mergeTimesFromSchedulings } from '@src/domains/scheduling/core/mergeTimesFromSchedulings';
import { resolveSchedulingsForDate } from '@src/domains/scheduling/core/resolveSchedulingsForDate';
import type { PackageProductDates } from '../intersectPackageAvailableDates';

export type PackageProductScheduleForTimes = {
  sellingMode: SellingMode;
  dates: PackageProductDates;
};

export function resolvePackageCommonScheduleTimes(
  schedules: PackageProductScheduleForTimes[],
  selectedDate: string | undefined,
): ScheduleTime[] {
  if (!selectedDate) {
    return [];
  }

  const sources = schedules
    .filter((entry) => entry.sellingMode === SellingMode.WithDateAndTime)
    .map((entry) => {
      const schedulings = resolveSchedulingsForDate(entry.dates, selectedDate)?.availables ?? [];
      return { availableScheduleTimes: mergeTimesFromSchedulings(schedulings) };
    });

  return intersectCommonScheduleTimes(sources);
}

export function isPackageCommonHourSelectionValid(
  schedules: PackageProductScheduleForTimes[],
  selectedDate: string | undefined,
  selectedHour: ScheduleTime | undefined,
): boolean {
  const commonTimes = resolvePackageCommonScheduleTimes(schedules, selectedDate);

  if (commonTimes.length === 0) {
    return false;
  }

  if (!selectedHour) {
    return false;
  }

  return commonTimes.some((time) => time.minutes === selectedHour.minutes);
}
